import styled from 'styled-components';
import { Grid } from '../../../app/StyleGuide';
import { Container } from '../../../components/Layout';

export const PageContainer = styled(Container)`
  margin-top: ${Grid._5};
  margin-bottom: ${Grid._7};
`;
